var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-container"},[_c('div',{ref:"rank_ref",staticClass:"com-echarts",style:({ height: _vm.height + 'px' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }